import { render, staticRenderFns } from "./DiceResult.vue?vue&type=template&id=e074521e&"
import script from "./DiceResult.vue?vue&type=script&lang=js&"
export * from "./DiceResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports